module.exports = "<div class=\"toast\" ng-if=\"toast.visible\" ng-click=\"toast.hide()\">\n  <div class=\"toast-backdrop\"></div>\n  <div class=\"toast-view\">\n    <div class=\"toast-message\">{{toast.message}}</div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/alert/toast.html
// module id = 94
// module chunks = 0